import { playVo } from './audio';

export default class Characters {
  constructor(id, vo) {
    this.id = id || false;
    this.vo = vo || {};
    this.currentIndex = 0;
    this.transitionInProgress = false;
    this.characters = null;
    this.targetElement = null;

    this.triggerVo = this.triggerVo.bind(this);
    this.swapCharacter = this.swapCharacter.bind(this);

    if (this.id) {
      this.targetElement = document.getElementById(this.id) || false;

      if (this.targetElement) {
        this.characters = Array.from(this.targetElement.querySelectorAll('.character'));
        this.addEvents();
      }
    } else {
      console.warn('No id provided');
    }
  }

  addEvents() {
    this.targetElement.addEventListener('click', this.swapCharacter);
    this.targetElement.addEventListener('touchstart', this.swapCharacter);
  }

  triggerVo(index) {
    playVo(this.vo[index % this.vo.length], true);
  }

  swapCharacter() {
    if (this.transitionInProgress) return; // Exit early if transition is already in progress

    const currentCharacter = this.characters[this.currentIndex];
    const nextIndex = (this.currentIndex + 1) % this.characters.length;
    const nextCharacter = this.characters[nextIndex];

    // if its there - remove display none from next character
    nextCharacter.style.display = '';
    // trigger VO
    this.triggerVo(nextIndex);

    setTimeout(() => {
      currentCharacter.classList.remove('visible');
      this.transitionInProgress = true; // Set transition in progress
    }, 100); // Adjust the delay time (in milliseconds) as needed

    setTimeout(() => {
      nextCharacter.classList.add('visible');
      this.currentIndex = nextIndex;
      this.transitionInProgress = false; // Reset transition status
    }, 500); // Adjust the delay time (in milliseconds) as needed
  }
}
